import {COLOR_SCHEMES} from './../constants/globalConstants';

const overrideOsDarkModeFromLocalStorage = localStorage.getItem('overrideOsDarkMode') ? localStorage.getItem('overrideOsDarkMode') : null;
if (overrideOsDarkModeFromLocalStorage === 'true') {
  const prefersColorSchemeFromLocalStorage = localStorage.getItem('prefersColorScheme') ? localStorage.getItem('prefersColorScheme') : null;
  if (prefersColorSchemeFromLocalStorage) {
    document.documentElement.setAttribute('data-theme', prefersColorSchemeFromLocalStorage);
  } else {
    document.documentElement.setAttribute('data-theme', COLOR_SCHEMES.DARK.CONSTANT);
  }
} else if (window.matchMedia) {
  if (window.matchMedia('screen and (prefers-color-scheme: dark)').matches) {
    document.documentElement.setAttribute('data-theme', COLOR_SCHEMES.DARK.CONSTANT);
  } else {
    document.documentElement.setAttribute('data-theme', COLOR_SCHEMES.LIGHT.CONSTANT);
  }
}
if (window.matchMedia) {
  window.matchMedia('screen and (prefers-color-scheme: dark)').addListener(event => {
    const overrideOsDarkModeFromLocalStorage = localStorage.getItem('overrideOsDarkMode') ? localStorage.getItem('overrideOsDarkMode') : null;
    if (overrideOsDarkModeFromLocalStorage === 'true') {
      document.documentElement.setAttribute('data-theme', localStorage.getItem('prefersColorScheme'));
    } else if (event.matches) {
      document.documentElement.setAttribute('data-theme', COLOR_SCHEMES.DARK.CONSTANT);
    } else {
      document.documentElement.setAttribute('data-theme', COLOR_SCHEMES.LIGHT.CONSTANT);
    }
  });
}
